import React, { ReactNode } from 'react';
import { LocationSelectionInput } from '~/Components/LocationSelectionInput';
import { ILocation } from '~/Models/DTO/Location.models';
import { ItemCreationFieldValue } from '~/Components';

interface EventLocationSelectionProps {
  name: string;
  selectedLocationId: string;
  children: ReactNode;
  setFieldValue: ItemCreationFieldValue;
  disabled?: boolean;
}

export const EventLocationSelection = ({
  name,
  selectedLocationId,
  children,
  setFieldValue,
  disabled,
}: EventLocationSelectionProps) => {
  const updateLocation = (location: ILocation) => {
    setFieldValue(name, location?.id);
  };

  return (
    <LocationSelectionInput
      selectedLocationId={selectedLocationId}
      updateLocation={updateLocation}
      disabled={disabled}
    >
      {children}
    </LocationSelectionInput>
  );
};
